import CdbjjNav from "./components/CdbjjNav";
import CdbjjHero from "./components/CdbjjHero";
import CdbjjBrand from "./components/CdbjjBrand";
import ProductGridCdbjj from "./components/ProductGridCdbjj";
import ProductDetailSectionsCdbjj from "./components/ProductDetailCdbjj";
import CdbjjFooter from "./components/CdbjjFooter";

export default function CdbjjPage() {
  return (
    <main className="bg-black min-h-screen w-full overflow-x-hidden">
      <CdbjjNav />
      <CdbjjHero />
      <CdbjjBrand />
      <ProductGridCdbjj />
      <ProductDetailSectionsCdbjj />
      <CdbjjFooter />
    </main>
  );
}
